/** 
 * @Desc: 资源预览--视频 doc ppt pdf
 */ 
<template>
  <div class="resource-preview-box">
    <!-- 视频 vs4 播放 -->
    <video-drag
      v-if="videoVisible"
      ref="videoDragRef"
      :videoInfo="vs4Video"
      :needStatistics="needStatistics"
      @handleClose="_vs4Close"
    />

    <!-- PDF预览 教案 课件 教案课件 习题 交互课件 -->
    <pdf-preview
      v-if="pdfPreviewVisible"
      :data-info="resourceItem"
      :img-src="imgSrc"
      :needStatistics="needStatistics"
      @handleClose="_pdfPreviewClose"
    />

    <!-- 专题包 播放 -->
    <video-list
      v-if="packageResourceId"
      ref="listVideoRef"
      :resourceItem="previewItem"
      :resourceTitle="(previewItem && previewItem.resourceTitle) || resourceTitle"
      :videoList="videoList"
      :resourceId="packageResourceId"
      :needStatistics="needStatistics"
      @handleClose="_vs4Close"
    />
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { originUrl } from "config/constant";
import videoDrag from "components/h5video/video-drag";
import videoList from "components/h5video/video-list";
import PdfPreview from "components/learn-task/pdf-preview";
import { localStorageUtil, sessionStorageUtil, debounce, formatDateTime, getFileSuffix } from 'utils/util';
import { SetVideoStatistics } from 'api/common';
export default {
  name: 'resource-preview',
  components: {
    videoDrag,
    videoList,
    PdfPreview,
  },
  props: {
    previewItem: {
      type: Object
    },
    resourceTitle: {
      type: String
    },
    resourceList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    needStatistics: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      imgSrc:
        originUrl.indexOf("http://localhost") !== -1
          ? "http://mvr-learning.viewshare.net"
          : originUrl,
      videoVisible: false,
      vs4Video: {},
      mediaViewer: null,
      pdfPreviewVisible: false,
      resourceItem: null,

      packageResourceId: null,
      videoList: [],
    }
  },
  watch: {
    previewItem: {
      handler: true,
      immediate: true,
      handler(val, oldVal) {
        if(val && (val.resourceId || val.documentId)) {
          this._previewResource(val);
        }else if(!val && oldVal && oldVal.resourceId) {
          this._previewClear();
        }
      }
    }
  },
  methods: {

    /**
     * 预览
     */
    _previewResource(item) {
      let type = {
        MP3: "MP3",
        MP4: "MP4",
        // FLV: "FLV",
        MOV: "MOV",
        OGG: "OGG",
        WEBM: "WEBM",
        WAV: "WAV",
        AAC: "AAC",
        PNG: "PNG",
        JPG: "JPG",
        GIF: "GIF",
        JPEG: "JPEG"
      };
      let isPreview = true;
      if(item.type === 21) { // 专题包
        if(item.status === 2) {
          isPreview = false;
          return;
        }
        if (this.videoVisible) {
          this.$refs.videoDragRef._vs4Close("switch");
          this.videoVisible = false;
        }
        if (this.mediaViewer && $("#_preview").length) {
          this.mediaViewer.close();
        }
        if (this.pdfPreviewVisible) {
          this.resourceItem = null;
          this.pdfPreviewVisible = false;
        }
        this.packageResourceId = item.resourceId;
      } else if (getFileSuffix(item.fileUrl, "toUpperCase") === "VS4" || ((item.type === 1 || item.type === 3 || item.type === 8) &&  getFileSuffix(item.fileUrl, "toUpperCase") === "MP4")) {
        // 专题包
        if (this.packageResourceId) {
          this.$refs.listVideoRef._vs4Close("switch");
          this.packageResourceId = null;
        }
        // vs4播放
        if (this.mediaViewer && $("#_preview").length) {
          this.mediaViewer.close();
        }
        if (this.pdfPreviewVisible) {
          this.resourceItem = null;
          this.pdfPreviewVisible = false;
        }
        this._getVideoDetailData(item, false);
      } else if (type[getFileSuffix(item.fileUrl, "toUpperCase")]) {
        // 专题包
        if (this.packageResourceId) {
          this.$refs.listVideoRef._vs4Close("switch");
          this.packageResourceId = null;
        }
        if (this.videoVisible) {
          this.$refs.videoDragRef._vs4Close("switch");
          this.videoVisible = false;
        }

        if (this.pdfPreviewVisible) {
          this.resourceItem = null;
          this.pdfPreviewVisible = false;
        }
        let list = [];
        for (let x of this.resourceList) {
          if (type[getFileSuffix(x.fileUrl, "toUpperCase")]) {
            let fileUrl = '', coverUrl = x.coverUrl, _type = x.type, needJoin = false;
            if(x.source === 1 && x.fileType) {
              if(x.fileType === 1) {
                _type = 11;
                needJoin = true;
              }else if(x.fileType === 3) {
                _type = 10;
                needJoin = true;
              }
            }else if(x.resourceType === 1 && x.sourceResourceType) {
              _type = x.sourceResourceType;
              needJoin = true;
            }else if(!x.source && !x.resourceType) {
              needJoin = true;
            }
            // 图片 音频
            if(x.previewUrl) {
              fileUrl = x.previewUrl;
            }else if(needJoin && (_type === 10 || _type === 11)) {
              fileUrl = `${this.imgSrc}/resource/${x.preUrl}/${x.resourceId}/${x.fileUrl}`;
              coverUrl = `${this.imgSrc}/images/${x.preUrl}/${x.resourceId}/${x.coverUrl}`;
            }else {
              fileUrl = this.imgSrc + "/" + x.fileUrl;
            }
            let o = {};
            if(x.resourceId && (x.detailSourceType === 1 || x.source === 1) && (_type === 10 || _type === 11) && (!x.transcodeStatus || x.transcodeStatus === 3)) {
              o.resourceId = x.resourceId;
              o.levelId = x.level || x.levelId;
              o.subjectId = x.subject || x.subjectId;
              o.resourceType = _type;
            }
            list.push({
              file: fileUrl, // 文件地址（展示和下载）
              image: coverUrl, // 文件的封面图片地址
              canDownload: false, // 文件的下载地址
              title: x.resourceTitle, // 文件标题
              size: 0, // 文件大小
              id: x.id,
              ...o
            });
          }
        }
        let nowIndex = list.findIndex(ele => ele.title === item.resourceTitle);
        this._mediaPlay(list, nowIndex);
      } else if ((item.type >= 4 && item.type <= 7) || item.type === 2 || item.type === 9) {
        // 专题包
        if (this.packageResourceId) {
          this.$refs.listVideoRef._vs4Close("switch");
          this.packageResourceId = null;
        }
        // pdf预览
        if (this.mediaViewer && $("#_preview").length) {
          this.mediaViewer.close();
        }
        if (this.videoVisible) {
          this.$refs.videoDragRef._vs4Close("switch");
          this.videoVisible = false;
        }
        this.resourceItem = item;
        this.pdfPreviewVisible = true;
      } else {
        isPreview = false;
        console.log('other preview', item);
      }
      if(isPreview) {
        this.$emit('handlerResourceClick', item);
      }
    },
    /**
     * 清空预览
     */
    _previewClear() {
      if (this.packageResourceId && this.$refs.listVideoRef) {
        this.$refs.listVideoRef._vs4Close();
        this.packageResourceId = null;
      }
      if (this.videoVisible && this.$refs.videoDragRef) {
        this.$refs.videoDragRef._vs4Close();
        this.videoVisible = false;
      }
      if (this.mediaViewer && $("#_preview").length) {
        this.mediaViewer.close();
      }
      if (this.pdfPreviewVisible) {
        this.resourceItem = null;
        this.pdfPreviewVisible = false;
      }
      this.vs4Video = {};
    },
    
    /**
     * 资源--预览--vs4
     * @param {String} id: 请求的资源Id
     */
    _getVideoDetailData(data, isTrySee) {
      if (this.videoVisible) {
        this.$refs.videoDragRef._vs4Close("switch");
      }
      this.videoVisible = true;
      this.vs4Video.loading = true;
      this.vs4Video.loading = false;
      let _coverUrl = "";
      if(data.coverUrl) {
        let i = data.coverUrl.indexOf(".net/") || val.coverUrl.indexOf(".com/") || val.coverUrl.indexOf(".cn/");
        if (i !== -1) {
          let str = "";
          if (data.coverUrl.indexOf(".net/") !== -1 || data.coverUrl.indexOf(".com/") !== -1) {
            str = data.coverUrl.substr(i + 4, data.coverUrl.length);
          } else if (data.coverUrl.indexOf(".cn/") !== -1) {
            str = data.coverUrl.substr(i + 3, data.coverUrl.length);
          }
          _coverUrl = str;
        } else if(data.coverUrl.indexOf("/") === -1) {
          _coverUrl = `/images/${data.preUrl}/${data.resourceId}/${data.coverUrl}`;
        } else {
          _coverUrl = `/${data.coverUrl}`;
        }
      }
      this.vs4Video = {
        loading: false,
        isTrailer: data.isTrailer,
        trailerDuration: data.isTrailer && data.trailerDuration ? data.trailerDuration : 0,
        resourceId: data.resourceId,
        videoUrl: `/teacher/resourceAuthentication/${data.resourceId}`,
        coverUrl: _coverUrl,
        enValue: "",
        zhValue: "",
        enAndzhValue: "",
        tValue: "bearer " + Cookies.get("mvr_student_Token"),
        title: data.resourceTitle ? data.resourceTitle : data.fileName,
        hadLogo: data.hadLogo,
      };
      if(data.fileUrl && data.fileUrl.indexOf('.mp4') === data.fileUrl.length - 4 && data.fileUrl.indexOf('http') === 0) {
        this.vs4Video.videoUrl = data.fileUrl;
      }
      if(this.needStatistics) {
        if(data.levelId || data.level) {
          this.vs4Video.level = data.levelId || data.level;
        }
        if(data.subjectId || data.subject) {
          this.vs4Video.subject = data.subjectId || data.subject;
        }
      }
      console.log("this.vs4Video", this.vs4Video);
    },

    /**
     * 资源--预览--vs4关闭预览
     * **/
    _vs4Close(type = 'video') {
      if(type === 'video') {
        this.videoVisible = false;
      }else if(type === 'list-video') {
        this.packageResourceId = null;
      }
    },

    

    /**
     * 资源--预览--media-viewer播放器
     * **/
    _mediaPlay(list, index) {
      let nowIndex = index,
        dataList = list;

      if (!dataList.length) {
        return;
      }
      if (this.mediaViewer && $("#_preview").length) {
        this.mediaViewer.again(nowIndex);
      } else {
        this.mediaViewer = new MediaViewer({
          canDownload: false,
          nowIndex: nowIndex ? nowIndex : 0,
          dataList: dataList,
          backgroundColor: "#03B2B2",
          playChange: (data) => {
            let _objIndex = this.resourceList.findIndex(ele => ele.id === data.id);
            let _index = dataList.findIndex(ele => ele.id === data.id);
            if(_index !== _objIndex && _objIndex !== -1 && !this.resourceList[_objIndex].isWatched) {
              this.$emit('handlerResourceClick', Object.assign({index: _objIndex}, this.resourceList[_objIndex]));
            }
            this._mediaStatistics(data);
          }
          // id: '',
          // width: 800,
          // height: 580
        });
      }
    },
    /**
     * media-viewer 音视频预览统计跟踪
     * **/
    _mediaStatistics(item) {
      if(this.needStatistics && item.resourceId) {
        SetVideoStatistics({
          boxId: item.resourceType === 10 ? '' : '#container',
          resourceId: item.resourceId,
          level: item.levelId,
          subject: item.subjectId,
          type: item.resourceType === 10 ? 'preview' : undefined,
        });
      }
    },

    /**
     * 资源--预览--pdf格式的文件预览
     * **/
    _pdfPreviewClose() {
      this.pdfPreviewVisible = false;
    },
  },
  destroyed() {
    this._previewClear();
  },
}
</script>
<style lang="less">
.resource-preview-box {
  position: fixed;
  z-index: 9999;
}
</style>